import fetch from "../../auth/FetchInterceptor";

export const createPart = function (data) {
  return fetch({
    url: '/parts',
    method: 'post',
    data
  })
}

export const updatePart = function (id, data) {
  return fetch({
    url: `/parts/${id}`,
    method: 'put',
    data
  })
}

export const getPart = function (id) {
  return fetch({
    url: `/parts/${id}`,
    method: 'get'
  })
}

export const deletePart = function (id) {
  return fetch({
    url: `/parts/${id}`,
    method: 'delete'
  })
}